import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {useNavigate} from 'react-router-dom'
import {createDepot, editDepot, getSources} from '../../../../components/requests'
import Select from 'react-select'
import {ModeleEditSource} from '../../../../components/Models'
import * as Yup from 'yup'

const validate = (values) => {
  const errors: {nom?: string; cp?: string; ville?: string; adresse?: string; source?: any, telephone?: string} = {}
  if (!values.nom) {
    errors.nom = 'Le nom est requis'
  }
  if (!values.cp) {
    errors.cp = 'Le code postal est requis'
  }
  if (!values.ville) {
    errors.ville = 'La ville est requise'
  }
  if (!values.adresse) {
    errors.adresse = "L'adresse est requise"
  }
  if (!values.source) {
    errors.source = 'La source est requise'
  }
  if (values.telephone) {
    const phoneCleaned = values.telephone.trim();
    const phoneRegex = /^(?:\+33|33|0)[\s.-]*[1-9](?:[\s.-]?\d{2}){4}$/;
    if (!phoneRegex.test(phoneCleaned)) {
      errors.telephone = 'Format invalide';
    }
  } else {
    errors.telephone = 'Le numéro de téléphone est requis';
  }
  return errors
}

const DepotForm = ({id, data}) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showErrorSource, setShowErrorSource] = useState<boolean>(false)
  const [sources, setSources] = useState<Array<ModeleEditSource>>([])
  const [sourceSelected, setSourceSelected] = useState<any>([])

  const formik = useFormik({
    initialValues: {
      nom: '',
      cp: '',
      ville: '',
      adresse: '',
      source: '',
      telephone: '',
    },
    validate,
    onSubmit: (values) => {
      submitDepot(values)
    },
  })

  const insertOrUpdateDepot = (values) => {
    let action
    if (data === null) {
      action = createDepot(values)
    } else {
      action = editDepot(id, values)
    }
    action
      .then((response) => {
        if (response?.data !== undefined && response?.status === 200) {
          setIsLoading(false)
          navigate('/depots/liste')
        }
      })
      .catch((error) => {
        console.log('erreur')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const submitDepot = (values) => {
    setIsLoading(true)
    insertOrUpdateDepot(values)
  }

  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('nom', data.nom)
      formik.setFieldValue('cp', data.cp)
      formik.setFieldValue('ville', data.ville)
      formik.setFieldValue('adresse', data.adresse)
      formik.setFieldValue('telephone', data.telephone)
      formik.setFieldValue('source', {value: data.sourceId, label: data.source})
      setSourceSelected([{value: data.sourceId, label: data.source}])
    }
  }, [data])

  useEffect(() => {
    const getSourcesData = () => {
      getSources()
        .then((sourcesRequest) => {
          if (sourcesRequest?.data !== undefined && sourcesRequest?.status === 200) {
            const transformedData = sourcesRequest.data.map((item) => ({
              value: item.id,
              label: item.libelle,
            }))
            setSources([...transformedData])
          }
        })
        .catch((e) => {
          console.log('erreur: ', e)
        })
    }
    getSourcesData()
  }, [])

  useEffect(() => {
    setShowErrorSource(sourceSelected.length === 0)
  }, [sourceSelected])

  const handleSourceChange = (e) => {
    setSourceSelected(e)
    formik.setFieldValue('source', e)
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Nom</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'nom'}
                    inputPlaceholder={'Nom'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Ville</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'ville'}
                    inputPlaceholder={'Ville'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Code postal</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'cp'}
                    inputPlaceholder={'Code postal'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Adresse</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'adresse'}
                    inputPlaceholder={'Adresse'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Téléphone</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'telephone'}
                    inputPlaceholder={'Téléphone'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className={`col-lg-4 col-form-label required fw-bold fs-6`}>Source</label>
            <div className='col-lg-4 fv-row'>
              <Select
                className='react-select-styled react-select-solid react-select-md'
                classNamePrefix='react-select'
                options={sources}
                fieldName='sources'
                placeholder='Sélectionner sources'
                value={sourceSelected}
                onChange={(e) => handleSourceChange(e)}
              />
            </div>
            {showErrorSource && (
              <div className='row mb-6'>
                <label className={`col-lg-4 col-form-label fw-bold fs-6`}></label>
                <div className='col-lg-8 fv-row text-danger fs-7'>La source est requise</div>
              </div>
            )}
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => {
              formik.resetForm()
              navigate(`/depots/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {DepotForm}
